import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { manageServicesAvailabilityShape } from 'constants/propTypes';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import When from 'components/When';
import { TooltipToggle, TooltipContent } from 'components/Tooltip';
import { ICONS } from 'constants/icons';
import { messages } from '../Resources.messages';
import { AvailabilitySummary } from '../../Components/AvailabilitySummary';

import './ResourcesListItem.scss';

const { block, element } = bem('resources-list-item');

const ResourcesListItem = ({ id, name, selectedResourceId, goToItem, recurrence, services }) => {
  const isSelected = id === selectedResourceId;
  const servicesLength = services?.length;
  const isDisabled = !servicesLength;

  return (
    <div className={withMods(block(), { isDisabled })}>
      {isSelected && <span className={element('selected-marker')} />}
      <button type="button" className={element('button')} onClick={goToItem} data-cypress="resources-list-item">
        <div className={element('box', 'grid grid--flush')}>
          <AvailabilitySummary name={name} recurrence={recurrence} />
          <When predicate={isDisabled}>
            <TooltipToggle name="service-disabled-tooltip">
              <Isvg src={ICONS.infoYellow} title="white exclamation mark on yellow background" />
            </TooltipToggle>
            <TooltipContent name="service-disabled-tooltip">
              <Message message={messages.list.disabledTooltip} />
            </TooltipContent>
          </When>
        </div>

        <When predicate={!!servicesLength}>
          <Message
            as="div"
            className="text--ui70"
            message={messages.list.servicesCount}
            values={{ servicesCount: servicesLength }}
          />
        </When>
      </button>
    </div>
  );
};

ResourcesListItem.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  selectedResourceId: PropTypes.number,
  goToItem: PropTypes.func,
  recurrence: manageServicesAvailabilityShape.recurrence,
  services: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, duration: PropTypes.number, name: PropTypes.string })
  ),
};

export default ResourcesListItem;
